import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./index.css";

/* Actions */
import { setLogOut } from "../../redux/actions/misc";

/* Components */
import { SidebarMenuButton, SidebarMenuSubButton } from "../SidebarMenuButtons";

class SidebarCandidate extends Component {

    getInitials = (firstName, lastName) => {
        const f = (firstName || "").trim().charAt(0).toUpperCase();
        const l = (lastName || "").trim().charAt(0).toUpperCase();
        return `${f}${l}` || "?";
    }

    render() {

        const onProfile = this.props.match.path.includes("/profile");
        const onSettings = this.props.match.path.includes("/settings");
        const { collapse } = this.props;
        const data = this.props.user?.data;
        const profileImage = data?.profile?.profileImage;
        const firstName = data?.firstName;
        const lastName = data?.lastName;
        const email = data?.email;
        const fullName = [firstName, lastName].filter(Boolean).join(" ") || "Your account";

        return(
            <div className="sidebar-candidate-container">
                <div className="sidebar-candidate-identity">
                    <div className="sidebar-candidate-avatar">
                        {profileImage
                            ? <img src={profileImage.startsWith("http") ? profileImage : profileImage} alt={fullName} />
                            : <span>{this.getInitials(firstName, lastName)}</span>
                        }
                    </div>
                    <div className="sidebar-candidate-identity-text">
                        <p className="sidebar-candidate-identity-name">{fullName}</p>
                        {email && <p className="sidebar-candidate-identity-email">{email}</p>}
                    </div>
                </div>

                <div className="sidebar-candidate-divider" />

                <nav className="sidebar-candidate-section">
                    <SidebarMenuButton active={this.props.match.path === "/" || this.props.match.path.includes("/jobs")} title={"Jobs"} path={"/"} collapse={collapse} />
                    <div className="sidebar-candidate-profile-group">
                        <SidebarMenuButton active={onProfile && !this.props.match.path.includes("/cv")} title={"Profile"} path={"/profile"} collapse={collapse} />
                        {onProfile &&
                            <SidebarMenuSubButton active={this.props.match.path === "/profile/cv"} title={"See your CV"} path={"/profile/cv"} collapse={collapse} />
                        }
                    </div>
                    <SidebarMenuButton active={onSettings} title={"Settings"} path={"/settings"} collapse={collapse} />
                </nav>

                <div className="sidebar-candidate-divider" />

                <div className="sidebar-candidate-section">
                    <SidebarMenuButton className="is-destructive" title={"Sign out"} path={"logout"} logout={true} handleLogout={this.props.setLogOut} destructive={true} />
                </div>
            </div>
        );

    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators({ setLogOut }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SidebarCandidate);
